"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingStageImpl = exports.OrganizationStatus = void 0;
var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["ACTIVE"] = "ACTIVE";
    OrganizationStatus["INACTIVE"] = "INACTIVE";
    OrganizationStatus["SUSPENDED"] = "SUSPENDED";
})(OrganizationStatus = exports.OrganizationStatus || (exports.OrganizationStatus = {}));
class OnboardingStageImpl {
    constructor({ allSet = false, importingCatalog = false, listingTool = false, createdInbound, completedInbound, } = {}) {
        this.allSet = allSet;
        this.completedInbound = completedInbound ? completedInbound : false;
        this.createdInbound = createdInbound ? createdInbound : false;
        this.importingCatalog = importingCatalog;
        this.listingTool = listingTool;
    }
}
exports.OnboardingStageImpl = OnboardingStageImpl;
//# sourceMappingURL=Organization.js.map